/**  @module Apparel/PrintDesign/CopyPrintPosition */
define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/locale",
	"Apparel/PrintDesign/PrintPositionMixin"
], function(declare,Copy,locale,PrintPositionMixin) {

	return declare([Copy,PrintPositionMixin], {
		
	});
});